import { render } from "./App.vue?vue&type=template&id=c4cd343c"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "@/assets/fonts.scss?vue&type=style&index=0&lang=scss"
import "./App.vue?vue&type=style&index=1&id=c4cd343c&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__